var ElementEmptyView;

ElementEmptyView = Marionette.ItemView.extend( {
	template: '#tmpl-kitbuilder-empty-preview',

	className: 'kitbuilder-empty-view',

	events: {
		'click': 'onClickAdd'
	},

	onClickAdd: function() {
		kitbuilder.getPanelView().setPage( 'elements' );
	}
} );

module.exports = ElementEmptyView;
